import handleError from "../../constants/handleError";
import {
  generateBILL_HA4_4PDF,
  generateIN_HA4_4PDF,
} from "./HalfA4Invoices/ClassicInvoice";
import {
  generateBILL_HA4_1PDF,
  generateIN_HA4_1PDF,
} from "./HalfA4Invoices/RetailInvoice";
import {
  generateBILL_HA4_3PDF,
  generateIN_HA4_3PDF,
} from "./HalfA4Invoices/CompactInvoice";
import {
  generateBILL_HA4_2PDF,
  generateIN_HA4_2PDF,
} from "./HalfA4Invoices/StandardReceipt";
import {
  Browser2InchBillReceipt,
  Browser2InchinvoiceReceipt,
  Browser3InchBillReceipt,
  Browser3InchinvoiceReceipt,
  Browser4InchBillReceipt,
  Browser4InchinvoiceReceipt,
} from "./Thermal_M1InchBrowser";
import {
  Generate2InchBillReceipt,
  Generate2InchinvoiceReceipt,
  Generate3InchBillReceipt,
  Generate3InchinvoiceReceipt,
  Generate4InchBillReceipt,
  Generate4InchinvoiceReceipt,
} from "./Thermal_M1InchGenerator";
import {
  Browser2InchBillReceiptM2,
  Browser2InchinvoiceReceiptM2,
  Browser3InchBillReceiptM2,
  Browser3InchinvoiceReceiptM2,
  Browser4InchBillReceiptM2,
  Browser4InchinvoiceReceiptM2,
} from "./Thermal_M2InchBrowser";
import {
  Generate2InchBillReceiptM2,
  Generate2InchinvoiceReceiptM2,
  Generate3InchBillReceiptM2,
  Generate3InchinvoiceReceiptM2,
  Generate4InchBillReceiptM2,
  Generate4InchinvoiceReceiptM2,
} from "./Thermal_M2InchGenerator";



export const handlePrint = async (
  data,
  showAlert,
  billing,
  selectedSize,
  handlePrintSystem,
  setPrint,
  selectTermalOption,
  generateBillingPDF,
  generateinvoicePDF,
  storeSettings,
  selectedTheme,
  checkNetwork,
  selectHALFA4Option,
  optData,
  isReturnHistory,
  overrideSize = null,
  settings
) => {
  setPrint(true);
  
  try {
    if (!checkNetwork()) return;
 
 
    const paperSize = overrideSize || selectedSize;
    const upperMode = data?.salemode?.toUpperCase();
 
    const isTaxBill =
      upperMode === "BILL" &&
      storeSettings?.saleSettings?.saleModeSettings?.isBill_isTax;
    let doc;
    let response;
    if (isReturnHistory && paperSize === "HALFA4") {
      doc = await generateinvoicePDF();
    }   
    if (!doc && upperMode === "BILL" && !isTaxBill) {
      if (paperSize === "2INCH") {
        if (
          selectTermalOption === "TMLBAS" ||
          selectTermalOption === "THERMALONE"
        ) {
          {
            billing
              ? (doc = await Generate2InchBillReceipt(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser2InchBillReceipt(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        } else if (
          selectTermalOption === "TMLMOD" ||
          selectTermalOption === "THERMALTWO"
        ) {
          {
            billing
              ? (doc = await Generate2InchBillReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser2InchBillReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        }
        const pdfBase64 = doc.output("datauristring").split(",")[1];
        response = await handlePrintSystem(
          pdfBase64,
          storeSettings?.printSystemSettings?.printerName,
        );
      } else if (paperSize === "3INCH") {
        if (
          selectTermalOption === "TMLBAS" ||
          selectTermalOption === "THERMALONE"
        ) {
          {
            billing
              ? (doc = await Generate3InchBillReceipt(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser3InchBillReceipt(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        } else if (
          selectTermalOption === "TMLMOD" ||
          selectTermalOption === "THERMALTWO"
        ) {
          {
            billing
              ? (doc = await Generate3InchBillReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser3InchBillReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        }
        const pdfBase64 = doc.output("datauristring").split(",")[1];
        response = await handlePrintSystem(
          // data,
          pdfBase64,
          storeSettings?.printSystemSettings?.printerName,
        );
      } else if (paperSize === "4INCH") {
        if (
          selectTermalOption === "TMLBAS" ||
          selectTermalOption === "THERMALONE"
        ) {
          {
            billing
              ? (doc = await Generate4InchBillReceipt(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser4InchBillReceipt(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        } else if (
          selectTermalOption === "TMLMOD" ||
          selectTermalOption === "THERMALTWO"
        ) {
          {
            billing
              ? (doc = await Generate4InchBillReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser4InchBillReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        }
        const pdfBase64 = doc.output("datauristring").split(",")[1];
        response = await handlePrintSystem(
          pdfBase64,
          storeSettings?.printSystemSettings?.printerName,
        );
      } else if (paperSize === "HALFA4") {
        if (selectHALFA4Option === "HA4RET") {
          doc = await generateBILL_HA4_1PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        } else if (selectHALFA4Option === "HA4SRT") {
          doc = await generateBILL_HA4_2PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        } else if (selectHALFA4Option === "HA4CMP") {
          doc = await generateBILL_HA4_3PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        } else if (selectHALFA4Option === "HA4CLS") {
          doc = await generateBILL_HA4_4PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        }
         else if (selectHALFA4Option === "HA4RES") {
          doc = await generateBillingPDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        }
      } else if (paperSize === "A4") {
        doc = await generateBillingPDF();
      } else {
        setPrint(false);
        return;
      }
    } else if (!doc)  {
      if (paperSize === "2INCH") {
        if (
          selectTermalOption === "TMLBAS" ||
          selectTermalOption === "THERMALONE"
        ) {
          {
            billing
              ? (doc = await Generate2InchinvoiceReceipt(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser2InchinvoiceReceipt(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        } else if (
          selectTermalOption === "TMLMOD" ||
          selectTermalOption === "THERMALTWO"
        ) {
          {
            billing
              ? (doc = await Generate2InchinvoiceReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser2InchinvoiceReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        }
        const pdfBase64 = doc.output("datauristring").split(",")[1];
        response = await handlePrintSystem(
          pdfBase64,
          storeSettings?.printSystemSettings?.printerName,
        );
      } else if (paperSize === "3INCH") {
        if (
          selectTermalOption === "TMLBAS" ||
          selectTermalOption === "THERMALONE"
        ) {
          {
            billing
              ? (doc = await Generate3InchinvoiceReceipt(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser3InchinvoiceReceipt(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        } else if (
          selectTermalOption === "TMLMOD" ||
          selectTermalOption === "THERMALTWO"
        ) {
          {
            billing
              ? (doc = await Generate3InchinvoiceReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser3InchinvoiceReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        }
        const pdfBase64 = doc.output("datauristring").split(",")[1];
        response = await handlePrintSystem(
          // data,
          pdfBase64,
          storeSettings?.printSystemSettings?.printerName,
        );
      } else if (paperSize === "4INCH") {
        if (
          selectTermalOption === "TMLBAS" ||
          selectTermalOption === "THERMALONE"
        ) {
          {
            billing
              ? (doc = await Generate4InchinvoiceReceipt(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser4InchinvoiceReceipt(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        } else if (
          selectTermalOption === "TMLMOD" ||
          selectTermalOption === "THERMALTWO"
        ) {
          {
            billing
              ? (doc = await Generate4InchinvoiceReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ))
              : (doc = await Browser4InchinvoiceReceiptM2(
                  data,
                  storeSettings,
                  optData,
                ));
          }
        }
        const pdfBase64 = doc.output("datauristring").split(",")[1];
        response = await handlePrintSystem(
          pdfBase64,
          storeSettings?.printSystemSettings?.printerName,
        );
      } else if (paperSize === "HALFA4") {
        if (selectHALFA4Option === "HA4RET") {
          doc = await generateIN_HA4_1PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        } else if (selectHALFA4Option === "HA4SRT") {
          doc = await generateIN_HA4_2PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        } else if (selectHALFA4Option === "HA4CMP") {
          doc = await generateIN_HA4_3PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        } else if (selectHALFA4Option === "HA4CLS") {
          doc = await generateIN_HA4_4PDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        }
         else if (selectHALFA4Option === "HA4RES") {
          doc = await generateinvoicePDF(
            data,
            storeSettings,
            selectedTheme,
            optData,
          );
        }
      } else if (paperSize === "A4") {
        doc = await generateinvoicePDF();
      } else {
        setPrint(false);
        return;
      }
    }

    if (!storeSettings?.printSystemSettings?.printThrough || !response) {
      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle"),
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    }
  } catch (error) {
    setPrint(false);
    handleError(error, showAlert);
    return false;
  } finally {
    setPrint(false);
  }
};
